<template>
  <div id="app">
    <header>
      <Navbar />
      <div v-if="hasBreadcrumbs" class="app-container">
        <AlBreadcrumb :items="breadcrumbs" />
      </div>
    </header>
    <main data-testid="router-output">
      <div class="app-container">
        <router-view v-acl:can_view_capacity_planner="me"></router-view>
      </div>
    </main>
    <div
      data-testid="no-access-message"
      class="not-found"
      v-acl:can_view_capacity_planner.false="me"
    >
      <h1><Localization message="capacity-planner" /></h1>
      <NotFound />
    </div>
  </div>
</template>

<script>
import { AlBreadcrumb } from "@playvox/almendra-components";
import {
  Navbar,
  Me,
  NotFound,
  Localization,
  Translator,
} from "@agyletime/wfm-vue-common";
import { addPendo } from "./config/pendo";

export default {
  name: "App",
  components: {
    Navbar,
    NotFound,
    Localization,
    AlBreadcrumb,
  },
  mixins: [Me, Translator],
  created() {
    this.initPendo();
  },
  data() {
    return {
      breadcrumbs: [],
      pendoInit: false,
    };
  },
  watch: {
    $route(to) {
      this.breadcrumbs = this.getBreadcrumbs(to);
    },
    me: {
      handler() {
        this.initPendo();
      },
      deep: true,
    },
  },
  computed: {
    hasBreadcrumbs() {
      return this.breadcrumbs.length > 0;
    },
  },
  methods: {
    initPendo() {
      if (
        !this.pendoInit &&
        this.me?.team?.id &&
        this.featureEnabled("pendo-enabled")
      ) {
        this.pendoInit = true;
        const key = window.PlayvoxWFM.featureflow
          .evaluate("pendo-web-key")
          .value();
        addPendo(key, this.me);
      }
    },
    onLanguageChange() {
      this.breadcrumbs = this.getBreadcrumbs(this.$router.currentRoute);
    },
    getBreadcrumbs(route) {
      const crumbs = this.getClosestMatchWithBreadcrumbs(route);
      if (!crumbs || crumbs.length === 0) {
        return [];
      }

      return [
        ...crumbs.map((bc) => this.parseBreadcrumbToRoute(bc)),
        this.parseBreadcrumbToRoute(
          {
            ...route,
            text: this.getClosestMatchWithText(route),
          },
          true
        ),
      ];
    },
    featureEnabled(key) {
      return window.PlayvoxWFM.featureflow.evaluate(key).isOn();
    },
    getClosestMatchWithBreadcrumbs(route) {
      const bcs = route.matched.filter((route) =>
        Boolean(route.meta.breadcrumbs)
      );

      return bcs.length > 0 ? bcs[bcs.length - 1].meta.breadcrumbs : [];
    },
    getClosestMatchWithText(route) {
      const bcs = route.matched.filter((route) => Boolean(route.meta.text));

      return bcs.length > 0 ? bcs[bcs.length - 1].meta.text : [];
    },
    parseBreadcrumbToRoute(breadcrumb, active = false) {
      return {
        text: this.translate(breadcrumb.text),
        to: this.$router.resolve({ name: breadcrumb.name }).route.path,
        active,
      };
    },
  },
};
</script>

<style lang="scss">
html {
  color: var(--color-eerie-black-80);
  --max-width: 1980px;
}

.app-container {
  max-width: var(--max-width);
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 24px;

  & > * {
    width: 100%;
  }
}

// small margin for small screens
@media (max-width: 1980px) {
  .app-container {
    margin-left: 48px;
    margin-right: 48px;
  }
}
@media (max-width: 899px) {
  .app-container {
    margin-left: 24px;
    margin-right: 24px;
  }
}
@media (max-width: 599px) {
  .app-container {
    margin-left: 12px;
    margin-right: 12px;
    margin-top: 12px;
  }
}
</style>
